import type { TAnalyticsEvent } from '@hooks/analytics';

const BLOCK_ANALYTICS_BASE: Omit<TAnalyticsEvent, 'pageName'> = {
	eventName: 'page.interaction',
	pageType: 'chat',
	flowType: 'garagem',
	tier: 3,
	recurringEvent: true,
};

export const BLOCK_EVENTS = {
	menuOpen: { ...BLOCK_ANALYTICS_BASE, pageName: 'chat-menu-bloqueio-garagem' },
	blockMenuClick: { ...BLOCK_ANALYTICS_BASE, pageName: 'chat-menu-bloquear-mensagem-garagem' },
	confirmBlock: { ...BLOCK_ANALYTICS_BASE, pageName: 'chat-menu-sim-quero-bloquear-mensagem-modal-garagem' },
	cancelBlock: { ...BLOCK_ANALYTICS_BASE, pageName: 'chat-menu-cancelar-modal-garagem' },
	unblockMenuClick: { ...BLOCK_ANALYTICS_BASE, pageName: 'chat-menu-desbloquear-usuario-garagem' },
	confirmUnblock: { ...BLOCK_ANALYTICS_BASE, pageName: 'chat-menu-confirmar-desbloquear-modal-garagem' },
	cancelUnblock: { ...BLOCK_ANALYTICS_BASE, pageName: 'chat-menu-cancelar-desbloquear-garagem' },
} as const;
